import { createContext, useContext, useState, useEffect } from 'react'

const PrivacyContext = createContext({ privacyMode: false, togglePrivacy: () => {} })

export function PrivacyProvider({ children }) {
  const [privacyMode, setPrivacyMode] = useState(() => {
    return localStorage.getItem('bwc-privacy-mode') === 'true'
  })

  useEffect(() => {
    localStorage.setItem('bwc-privacy-mode', String(privacyMode))
  }, [privacyMode])

  const togglePrivacy = () => setPrivacyMode(p => !p)

  return (
    <PrivacyContext.Provider value={{ privacyMode, togglePrivacy }}>
      {children}
    </PrivacyContext.Provider>
  )
}

export function usePrivacy() {
  return useContext(PrivacyContext)
}
